// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__b8a-V","content":"LayoutSettings_content__2Sh0w"};